import { c as _c } from "react/compiler-runtime";
import { CategoryItem } from './CategoryItem';
import { Category } from './functions/getCategories';
interface Props {
  categories: Category[];
}
export function CategoriesList(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.categories) {
    t0 = props.categories?.map(_temp);
    $[0] = props.categories;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <section className="grid auto-rows-fr grid-cols-2 gap-2 lg:grid-cols-3 lg:gap-4">{t0}</section>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(category) {
  return <CategoryItem key={category.id} category={category} />;
}